import React, { useMemo } from 'react';
import cn from 'classnames';
import styl from '../orderRevamp.module.scss'
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL} from '../../../veriables';
import { TouchableButton } from '../../common/Touchable/index';
import PropTypes from 'prop-types';

const SpeedOrderCancelationModal = ({cancelOrderConfirm, setCancelOrderConfirm, goToChecks, serverAppTheme}) => {
  const popupModal = useMemo(() => {
    const speedOrderModal = {
      margin:'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      borderRadius:"16px",
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
      minHeight: '216px',
      padding:'1.5rem'
    }
    const messageStyle = {color: serverAppTheme?.primary_text}
    const noButton = {
      border: serverAppTheme?.cancleBtn_Border,
      background: serverAppTheme?.OFF_Premise_Btn,
      color: serverAppTheme?.cancleBtn_font
    }

    return {speedOrderModal, messageStyle, noButton}
  }, [serverAppTheme])

    return (
        <Modal
            isOpen={cancelOrderConfirm}
            isModalCenter
            style={popupModal.speedOrderModal}
            customClass='h-100 w-100'
            customClass2='h-100 w-100'
            noBackground
        >
            <div className="col-12 h-100 justify-content-center align-items-center text-center h-100 " style={popupModal.messageStyle}>
                <div className='col-12 fs_18 fw-700 text-center h-20'>Are You Sure?</div>

                <div className="col-12 fs_15 fw-400 py-2 pt-3 text-center">
                  {CUSTOM_MESSAGES().CANCEL_ORDER}
                </div>
            </div>

            <div className="col-12 d-flex justify-content-center mt-4">
          <TouchableButton className={cn("col-6 mr-1 btn44  fs_24 fw-600", styl.btnSecondary)} style={popupModal.noButton} type="button" onClick={(e) => { setCancelOrderConfirm(false); e.preventDefault() }}>
                {LABEL().NO}
              </TouchableButton>
          <TouchableButton className={cn("col-6 ml-1 btn44 btn-ripple fs_24 fw-600", styl.btnPrimary)} type="button" onClick={(e) => { goToChecks(); e.preventDefault(); }}>
                {LABEL().YES}
              </TouchableButton>
            </div>
          {/* </div> */}
        </Modal>
    )
};
SpeedOrderCancelationModal.propTypes = {
  cancelOrderConfirm: PropTypes.bool,
  setCancelOrderConfirm: PropTypes.func,
  goToChecks: PropTypes.func,
  serverAppTheme: PropTypes.object,
};
SpeedOrderCancelationModal.defaultProps = {
  cancelOrderConfirm: false,
  setCancelOrderConfirm: () => {},
  goToChecks: () => {},
  serverAppTheme: {},
};
export default SpeedOrderCancelationModal;